/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Autocomplete constants
 */

export const SHOW_MOBILE_AUTOCOMPLETE = '@@nr/autocomplete/SHOW_MOBILE_AUTOCOMPLETE'
export const HIDE_MOBILE_AUTOCOMPLETE = '@@nr/autocomplete/HIDE_MOBILE_AUTOCOMPLETE'
export const SET_IS_CURRENT_LOCATION_LOADING = '@@nr/autocomplete/SET_IS_CURRENT_LOCATION_LOADING'
export const CLEAR_FETCHING_KEY = '@@nr/autocomplete/CLEAR_FETCHING_KEY'
export const SET_FETCHING_KEY = '@@nr/autocomplete/SET_FETCHING_KEY'
export const SET_MOBILE_ORIGIN = '@@nr/autocomplete/SET_MOBILE_ORIGIN'
export const SET_IS_FETCHING = '@@nr/autocomplete/SET_IS_FETCHING'
